import React from 'react';
import styled from 'styled-components';
import { BodyText, Button, CheckboxField, FlexRow, Grid, ModalWindow, Tooltip } from '../../../components';
import { NotificationMessage } from './NotificationMessage';
import { EditAddressDataEntry } from './EditAddressDataEntry';
import { Form } from 'formik';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

const UpdateModalWindowStyled = styled((props) => <Grid {...props} />)<{}>`
  width: 56vw;
  min-width: 550px;
`;

export interface IEditPropertyAddressModalProps {
  onClose: () => void;
  disableSubmitButton: boolean;
  skipAddressValidation: boolean;
}

export const EditPropertyAddressModal: React.FC<IEditPropertyAddressModalProps> = ({
  onClose,
  disableSubmitButton,
  skipAddressValidation,
}) => {
  return (
    <ModalWindow uitype={'fit'} title={'Edit Address'} onClose={onClose}>
      <Form>
        <UpdateModalWindowStyled>
          {NotificationMessage}
          <EditAddressDataEntry isRequired readOnlyState />
          <FlexRow verticalAlign="center">
            <Button data-test-id={`submit`} intent={'primary'} type="submit" disabled={disableSubmitButton}>
              Update
            </Button>
            <Button data-test-id={`cancel`} intent={'ghost'} isInline type="button" onClick={onClose}>
              Cancel
            </Button>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '-22px' }}>
              <CheckboxField name={'skipAddressValidation'} text={'Use Exact Address'} value={skipAddressValidation} />
              <Tooltip
                tooltipContent={
                  <BodyText>
                    Enabling this will store the address exactly as entered. It may result in the county or the state
                    being incorrect.
                  </BodyText>
                }
                trigger={'hover'}
                placement={'right'}
              >
                <InformationCircleIcon className={'h-6 w-6'} />
              </Tooltip>
            </div>
          </FlexRow>
        </UpdateModalWindowStyled>
      </Form>
    </ModalWindow>
  );
};
